import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import startCase from 'lodash/startCase'

import * as sessionUserSelector from 'selectors/sessionUser'
import { getFieldValue } from 'utils/ticketFields'

import Sidebar from 'components/Shared/Sidebar/RightSidebar'
import SidebarLogo from 'components/Shared/Sidebar/SidebarLogo/Index'
import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarSectionSecureText from 'components/Shared/Sidebar/SidebarSectionSecureText/Index'
import SidebarTicketParent from 'components/Shared/Sidebar/SidebarTicketParent/Index'
import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'
import SidebarTicketExternalIdSection from 'components/Shared/Sidebar/SidebarTicketExternalIdSection/Index'
import SidebarTicketUserSection from 'components/Shared/Sidebar/SidebarTicketUserSection/Index'
import SidebarBadgesSection from 'components/App/TicketsPage/shared/SidebarBadgesSection'
import SidebarStatusSection from './SidebarStatusSection'

const TicketPageSidebar = ({ ticket, isClone }) => {
  const { t } = useTranslation()
  const userTimeZone = useSelector(sessionUserSelector.timezone)

  const fields = ticket.detailsFields || []

  return (
    <Sidebar
      noCloseButton
      title={t('ticketPage.sidebarDetails')}
      dataTest='ticket-page-details'
    >
      <SidebarTicketExternalIdSection
        externalId={isClone ? '' : ticket.externalId}
        externalTicketLink={ticket.externalTicketLink}
      />

      <SidebarSection title={t('ticketPage.sidebarSectionRelayId')} copyText={isClone ? '' : ticket.id}>
        <SidebarText text={isClone ? '' : ticket.id} />
      </SidebarSection>

      {ticket.hierarchyEnabled && (
        <SidebarTicketParent
          parentTicket={ticket.parentTicket}
          ticketingSystemDisplayId={ticket.ticketingSystemDisplayId}
        />
      )}

      <SidebarSection title={t('ticketPage.sidebarSectionTicketingSystem')} copyText={ticket.ticketingSystemName}>
        <SidebarLogo img={ticket.ticketingSystemIcon} fallbackText={ticket.ticketingSystemName} />
      </SidebarSection>

      <SidebarStatusSection ticket={ticket} />

      <SidebarTicketUserSection
        userName={ticket.createByUser}
        userAvatarUrl={ticket.userAvatarUrl}
      />

      {fields.map(field => {
        if (field.fieldType === 'array') {
          return (
            <SidebarBadgesSection field={field} key={field.id} />
          )
        }

        const value = getFieldValue(field, userTimeZone)
        const isSecure = field.fieldType === 'encrypted_text'
        return (
          <SidebarSectionSecureText
            title={startCase(field.name)}
            key={field.id}
            tooltipText={field.tooltiptext}
            value={value}
            isSecure={isSecure}
          />
        )
      })}

    </Sidebar>
  )
}

TicketPageSidebar.propTypes = {
  ticket: PropTypes.object.isRequired,
  isClone: PropTypes.bool,
}

export default TicketPageSidebar
